import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import './Edit.scss'
import Loader from '../../../../images/loader.gif'
import Loaderr from '../../../../images/loder.gif.gif'
import { useToasts } from 'react-toast-notifications'

interface Props {
  mergedData: any
  isLoading: boolean
}
function WithdrawEdit({ mergedData, isLoading }: Props) {
  const { addToast } = useToasts()
  const authToken = sessionStorage.getItem('AdminId')
  const [loading, setLoading] = useState(true)
  const { id } = useParams()
  const [user, setUser] = useState<any>({})
  const [userStatus, setUserStatus] = useState('')
  const [statusLoading, setstatusLoading] = useState(false)

  useEffect(() => {
    if (!isLoading) {
      const findUser = mergedData.find((item: any) => item._id === id)
      setUser(findUser)
      setLoading(false)
    }
  }, [isLoading, id, mergedData])

  const updateUserStatus = () => {
    setstatusLoading(true)
    fetch(
      `https://blockchainasic-be.onrender.com/user/transaction/withdraw?id=${id}`,
      {
        method: 'post',
        headers: {
          'content-Type': 'application/json',
          Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          userId: user.userId,
          status: userStatus,
        }),
      },
    )
      .then((res) => {
        if (res.status === 200) {
          res.json().then((data) => {
            setstatusLoading(false)
            addToast(`Withdrawal ${userStatus}d`, {
              appearance: 'success',
              autoDismiss: true,
            })
            setTimeout(() => {
              window.location.reload()
            }, 4000)
          })
        } else {
          res.json().then((data) => {
            addToast(data.error, {
              appearance: 'error',
              autoDismiss: true,
            })
            setstatusLoading(false)
          })
        }
      })
      .catch(() => {
        setstatusLoading(false)
      })
  }

  return loading ? (
    <div className='loader'>
      <div>
        <img src={Loader} alt='' />
      </div>
    </div>
  ) : (
    <div className='deposit'>
      <div className='home_tag'>
        <h1>Update Deposit</h1>
      </div>
      <div className='deposit-wrap'>
        <div>
          <form action=''>
            <div className='card'>
              <p>Name</p>
              <div className='inputy'>
                <p>{user.owner.name}</p>
              </div>
            </div>
            <div className='card'>
              <p>Email</p>
              <div className='inputy'>
                <p>{user.owner.email}</p>
              </div>
            </div>
            <div className='card'>
              <p>Amount</p>
              <div className='inputy'>
                <p>${user.amount.toLocaleString()}</p>
              </div>
            </div>
            <div className='card'>
              <p>Status</p>
              <div className='inputy'>
                <p>{user.status}</p>
              </div>
            </div>
            <div className='card'>
              <p>Crypto</p>
              <div className='inputy'>
                <p>{user.crypto}</p>
              </div>
            </div>
            <div className='card'>
              <p>Additional Info</p>
              <div className='inputy'>
                <p>{user.desc}</p>
              </div>
            </div>
            <div className='card'>
              <p>Resloved</p>
              <div className='inputy'>
                <p>{`${user.success}`}</p>
              </div>
            </div>
            <div className='card'>
              <p>Date</p>
              <div className='inputy'>
                <p>
                  {new Date(user.createdAt).toDateString()},
                  {new Date(user.createdAt).toLocaleTimeString()}
                </p>
              </div>
            </div>
            <div className='card ong'>
              <p>Wallet Address</p>
              <div className='inputy'>
                <p>{user.walletAdd},</p>
              </div>
            </div>
          </form>
        </div>
        {!user.success && (
          <div className='edit-status'>
            <h2>Resolve Withdrawal</h2>
            <form action=''>
              <div className='card'>
                <select
                  name=''
                  id=''
                  onChange={(e) => {
                    setUserStatus(e.target.value)
                  }}
                >
                  <option value={''}>Set</option>
                  <option value={'approve'}>Approve</option>
                  <option value={'decline'}>Decline</option>
                </select>
                {statusLoading ? (
                  <img src={Loaderr} alt='' />
                ) : (
                  <button onClick={updateUserStatus}>Change</button>
                )}
              </div>
            </form>
          </div>
        )}
      </div>
    </div>
  )
}

export default WithdrawEdit
